import "./job-lists.scss";


const JobLists = {

}

export default JobLists;